import { render } from "./DialogDenyPurchaseWarning.vue?vue&type=template&id=3eeb4468&scoped=true"
import script from "./DialogDenyPurchaseWarning.vue?vue&type=script&lang=js"
export * from "./DialogDenyPurchaseWarning.vue?vue&type=script&lang=js"

import "./DialogDenyPurchaseWarning.vue?vue&type=style&index=0&id=3eeb4468&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3eeb4468"

export default script